import React from 'react';
import { Document, Page, Text, View, StyleSheet, Link } from '@react-pdf/renderer';
import {constants} from '../../constants';
import moment from 'moment';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF'
  },
  section: {
    margin: 15,
    padding: 10,
    flexGrow: 1
  },
  header:{
    marginBottom:10,
    marginTop:10,
    fontWeight:700
  },
  subHeader:{
    fontSize: 12,
    textDecorationStyle:'none',
    marginTop:10
  },
  institutionContent:{
    fontSize: 12,
    paddingLeft:8
  },
  examContent:{
    fontSize: 12,
    paddingLeft:8
  },
  infoText:{
    marginTop:10,
    fontSize: 12, 
  },
  link:{
    color: '#007bff'
  }
});
  
  // Create Document Component
  export const DownloadPDF = ({props}) => (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.header}>Your transcript request has been submitted</Text>
          <View style={styles.subHeader}>
            <Text>Confirmation has been sent to the email address provided.</Text>
            <Text style={{paddingTop:2}}>Please keep this information for your records.</Text>
          </View>
          <View>
          <Text style={styles.subHeader}>Order number: {props.orderNumber}</Text>
          <Text style={styles.subHeader}>Payment received: {props.date && moment(props.date).format('DD MMMM yyyy')}</Text>
          </View>
          <View>
          <Text style={styles.subHeader}>Student name: {props.name}</Text>
          <Text style={styles.subHeader}>Email: {props.email}</Text>
          </View>
          <Text style={styles.infoText}>Exam series:</Text>
          {props.directToPay? props.exams.map((item,index) => (
              <View key={index} style={[styles.examContent, {marginTop:8}]}>
                <Text style={{fontWeight:400}}>{item.session}</Text>
                <Text style={{paddingTop:2}}>{constants.EXAM_DETAILS.EXAM_NAME}</Text>
                <Text style={{paddingTop:2}}>{item.centreName}</Text>
              </View>)):
             props.exams.map((item) => ( 
            <View key={item.id} style={[styles.examContent, {marginTop:8}]}>
              <Text style={{fontWeight:400}}>{item.examSeries.month} {item.examSeries.year}</Text>
              <Text style={{paddingTop:2}}>{item.exam}</Text>
              <Text style={{paddingTop:2}}>{item.examCenter}</Text>
            </View>
          ))}
          <Text style={styles.infoText}>Institution(s)</Text>
          {props.directToPay? props.institutions.map((item,index) => (
            <View key={index} style={[styles.institutionContent, {marginTop:8}]}>
              <Text>{item.split(',')[0]}</Text>
            </View>)):
            props.institutions.map((item) => (
            <View key={item.id} style={[styles.institutionContent, {marginTop:8}]} break>
              <Text style={{fontWeight:400}}>{item.institute.split(',')[0]}</Text>
              <Text style={{paddingTop:2}}>{item.StreetRoadName}</Text>
              <Text style={{paddingTop:2}}>{item.CityTownName}, {item.CountyRegionName} {item.PostCode}</Text>
            </View>
          ))}
          <Text style={styles.subHeader}>Fee: $ {props.fee}</Text>
          <Text style={styles.subHeader}>Payment reference: {props.payReferenceNumber}</Text>          
          <Text style={[styles.infoText, {textAlign:"justify"}]} break>
            After payment is received, grade transcripts will be sent within 14 days.
            If you include a future exam series in the request, transcripts will be sent within 14 days of the future results release day.
            If you have a query about your application, contact Customer Services by emailing <Link src="mailto:info@cambridgeinternational.org" style={styles.link}>info@cambridgeinternational.org</Link> or call 917-810-2660 (toll free, open 24 hours).
          </Text>
        </View>
      </Page>
    </Document>
  );